// Type-specific detail fields for the activity composer + quick due-date chips.
import { TYPE_FIELDS } from "./activityMeta";

const chipCls = (on) => `px-2.5 py-1 rounded-md text-[12px] border transition-colors ${on ? "border-purple-400/60 bg-purple-500/20 text-purple-100" : "border-white/10 bg-white/[0.03] text-slate-400 hover:text-white"}`;
const lbl = "block text-[10.5px] uppercase tracking-widest text-slate-500 font-mono mb-1.5";
const inp = "w-full px-3 py-2 rounded-lg bg-white/[0.03] border border-white/10 focus:border-purple-400/60 outline-none text-sm text-white placeholder:text-slate-500";

export const isoIn = (days) => {
  const d = new Date(); d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const DUE = [["Today", 0], ["Tomorrow", 1], ["+3 days", 3], ["+1 week", 7], ["+2 weeks", 14]];

export function DueChips({ value, onChange, testid }) {
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {DUE.map(([l, n]) => <button key={l} type="button" onClick={() => onChange(isoIn(n))} className={chipCls(value === isoIn(n))}>{l}</button>)}
    </div>
  );
}

export default function TypeDetails({ type, details, onChange, aiTag = () => null, aiRing = () => "" }) {
  const fields = TYPE_FIELDS[type]?.fields || [];
  if (!fields.length) return null;
  const set = (k, v) => onChange({ ...details, [k]: v });
  return (
    <div className="grid sm:grid-cols-2 gap-3 rounded-xl border border-purple-400/15 bg-purple-500/[0.03] p-3" data-testid="activity-type-details">
      {fields.map((f) => (
        <div key={f.key} className={`${f.kind === "chips" && f.options.length > 3 ? "sm:col-span-2" : ""} ${aiRing(f.key) ? `${aiRing(f.key)} p-1.5` : ""}`}>
          {f.kind === "check" ? (
            <label className="flex items-center gap-2 text-[13px] text-white cursor-pointer pt-5">
              <input type="checkbox" checked={!!details[f.key]} onChange={(e) => set(f.key, e.target.checked)} className="w-4 h-4 accent-emerald-400" data-testid={`activity-detail-${f.key}`} /> {f.label}{aiTag(f.key)}
            </label>
          ) : (<>
            <label className={lbl}>{f.label}{aiTag(f.key)}</label>
            {f.kind === "chips" ? (
              <div className="flex flex-wrap gap-1.5" data-testid={`activity-detail-${f.key}`}>
                {f.options.map((o) => <button key={o} type="button" onClick={() => set(f.key, details[f.key] === o ? "" : o)} className={chipCls(details[f.key] === o)}>{o}</button>)}
              </div>
            ) : (
              <div className="relative">
                {f.kind === "money" && <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">£</span>}
                <input value={details[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} inputMode={f.kind === "money" ? "decimal" : undefined}
                  className={`${inp} ${f.kind === "money" ? "pl-7" : ""}`} data-testid={`activity-detail-${f.key}`} />
              </div>
            )}
          </>)}
        </div>
      ))}
    </div>
  );
}
